export default __webpack_public_path__ + "static/media/right.c01e4e83.svg";